import React from "react";
import { Link } from "react-router-dom";
import "./AboutSectionContentOnly.css";
const AboutSectionLinear = () => {
  return (
    <section id="about" className="dmt-linear-about-scope py-5">
      <div className="container" data-aos="fade-up">
        
        {/* Top Minimal Line Indicator */}
        <div className="dmt-top-accent-line"></div>

        {/* Corporate Header */}
        <div className="dmt-corporate-header mb-5">
          <span className="dmt-badge-text">CORPORATE OVERVIEW</span>
          <h2 className="dmt-main-title">About Us</h2>
        </div>

        {/* Linear Narrative Flow */}
        <div className="dmt-linear-content">
          
          {/* Main Statement / Lead Text */}
          <div className="dmt-lead-wrapper mb-2" data-aos="fade-up" data-aos-delay="100">
            <p className="dmt-lead-text text-justify">
              <strong>DMT Group of Companies</strong> is a professionally managed Indian business conglomerate established in 2015, with diversified interests across fintech, digital commerce, travel services, media & marketing, accounting solutions, and social welfare initiatives.
            </p>
          </div>

          {/* Subtext Decorative Line */}
          

          {/* Supporting Philosophy Text */}
          <div className="dmt-supporting-wrapper" data-aos="fade-up" data-aos-delay="200">
            <p className="dmt-supporting-text text-justify mb-1">
              The group operates through its esteemed entities — DMT Empire India Private Limited, Coupon Fares India Private Limited, DMT Media and Marketing Private Limited, and Shardajeet Foundation. Each organization has been strategically established to serve distinct business verticals while collectively contributing towards the group’s broader mission of digital empowerment, innovation, and sustainable growth.
            </p>
          </div>

          {/* Supporting Philosophy Text */}
          <div className="dmt-supporting-wrapper" data-aos="fade-up" data-aos-delay="200">
            <p className="dmt-supporting-text text-justify">
              At the core of DMT Group’s philosophy lies the mission of empowering lives through innovation and inclusive growth. By combining digital innovation with strong business ethics, DMT Group continues to contribute towards India’s vision of financial inclusion, digital transformation, and entrepreneurial empowerment. Its solutions are designed to cater to both urban and rural markets, ensuring accessibility, convenience, and value creation for customers and partners alike.
            </p>
          </div>

        </div>

        {/* Clean Architectural CTA Button */}
        <div className="dmt-action-wrapper mt-3 text-center" data-aos="fade-up" data-aos-delay="300">
          <Link to="/aboutus" className="dmt-linear-btn">
            <span>Read Full Corporate Profile</span>
            <svg className="dmt-btn-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default AboutSectionLinear;